<template>
<div>
  <div class="section-header">
    <h1 class="hide-at-xs">Client Dashboard</h1>
    <div>
      <h-select @change="startPagination()" :items="filters" itemText="display" itemValue="value"  v-model="filterBy" :noNone="true"/>
      <h-input class="search" style="margin-top: 10px; margin-bottom: 10px" placeholder="Search" type="search" v-model="search" @keydown="searchChange"/>
    </div>
  </div>
  <div class="card card--transparent" v-if="clients.length == 0 && !busy && search">
    <div class="card--container">
      No clients matching "{{search}}"
    </div>
  </div>
  <div v-infinite-scroll="findNext" infinite-scroll-disabled="busy" infinite-scroll-distance="600">
    <div class="card-rows">
      <client-card :client="client" v-for="client in clients" :key="client.id" />
    </div>
  </div>

</div>
  
</template>


<script>
import Paginator from "@/services/api/paginator";
import clientCard from "./clientCard";

export default {
  components: {
    clientCard
  },
  data() {
    return {
      clients: [],
      busy: true,
      debounceTimeout: undefined,
      search: undefined,
      filterBy: 'active',
      ordering: "-last_login",
      filters: [
        {display: 'Active Clients', value: 'active'},
        {display: 'Deactivated Clients', value: 'deactivated'},
        {display: 'All Clients', value: 'all'},
      ]
    };
  },
  created() {
    this.startPagination();
  },
  methods: {
    startPagination() {
      this.clients = [];
      let query = {
        currently_coaching: true,
        ordering: this.ordering,
        search: this.search,
        filter: this.filterBy.toLowerCase(),
      };
      this.pagination = new Paginator("CoachClients", query, 4);
      this.findNext();
    },
    removeClient(id) {
      this.clients = this.clients.filter(c => c.id !== id);
    },
    searchChange() {
      this.clients = [];
      clearTimeout(this.debounceTimeout);
      this.busy = true;
      this.debounceTimeout = setTimeout(() => {
        this.startPagination();
      }, 300);
    },
    findNext() {
      if (this.pagination.finished) {
        return;
      }
      this.busy = true;
      this.pagination.next().then(results => {
        this.clients = [...this.clients, ...results];
        this.busy = false;
      });
    }
  },
  // watch: {
  //   filterBy: function() {
  //     this.startPagination();
  //   }
  // }
};
</script>

<style lang="less">
// .search {
//   @media (max-width: 720px) {
//     display: flex;
//     flex-direction: column !important;
//     .section-ordering {
//       width: 100% !important;
//     }
//   }
// }
.section-filtering {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
}
.section-ordering {
  width: 250px;
}

// .search {
//   @media (max-width: 720px) {
//     width: 100%;
//     max-width: 300px;
//   }
// }
.search {
  background-color: white;
  border-radius: 20px;
  color: black;
}
</style>
